/*
 * @Author: EdwardYoung
 * @Date: 2017-07-25 23:09:58
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-08-24 17:29:17
 */

import axios from 'api/axios.js'
import {createApiHeader} from './createApiHeader.js'

/**
 * 为自己砍价
 */
async function sendStatToApi (uvKey, campaignId) {
  let customer = await new Promise((resolve, reject) => {
    window.yhsd.ready(function (sdk) {
      sdk.account.current(function (User) {
        resolve(User.res.customer)
      })
    })
  })
  createApiHeader(axios, customer)
  const url = `/v1/front/stat`
  return axios({
    method: 'GET',
    url: url,
    params: {
      k: uvKey,
      c: campaignId
    }
  })
}

export {sendStatToApi}



// WEBPACK FOOTER //
// ./src/api/sendStatToApi.js